import React from "react";
import EAButton from "../../shared/Buttons/EAButton";
import FormInput from "../../../../utils/FormInput";
import { nipValidator, zipCodeValidator } from "../../../../utils/formsValidation";

interface IProps {
  register: any;
  errors: any;
}

const FormPart1: React.FC<IProps> = ({ register, errors }: IProps) => {
  return (
    <>
      <FormInput
        name="nip"
        type="text"
        isLabel
        text="NIP firmy"
        errors={errors}
        register={{ ...register("nip", { ...nipValidator(true, true) }) }}
        isPlaceholder={false}
      />
      <FormInput
        name="fullName"
        type="text"
        isLabel
        text="Pełna nazwa firmy zgodna z KRS lub CEIDG"
        errors={errors}
        register={{ ...register("fullName", { require: true }) }}
        isPlaceholder={false}
      />
      <FormInput
        name="street"
        type="text"
        isLabel
        text="Ulica"
        errors={errors}
        register={{ ...register("street", { require: true }) }}
        isPlaceholder={false}
      />
      <div className="b2b-register-two-input">
        <FormInput
          name="houseNumber"
          type="text"
          isLabel
          text="Nr domu"
          errors={errors}
          register={{ ...register("houseNumber", { require: true }) }}
          isPlaceholder={false}
        />
        <FormInput
          name="flatNumber"
          type="text"
          isLabel
          text="Nr lokalu"
          errors={errors}
          register={{ ...register("flatNumber", { require: false }) }}
          isPlaceholder={false}
        />
      </div>
      <div className="b2b-register-two-input">
        <FormInput
          name="city"
          type="text"
          isLabel
          text="Miasto"
          errors={errors}
          register={{ ...register("city", { require: true }) }}
          isPlaceholder={false}
        />
        <FormInput
          name="zipCode"
          type="text"
          isLabel
          text="Kod pocztowy"
          errors={errors}
          register={{ ...register("zipCode", { ...zipCodeValidator(true) }) }}
          isPlaceholder={false}
        />
      </div>
      <div className="b2b-register-next">
        <EAButton title="Dalej" inputType="submit" />
      </div>
    </>
  );
};

export default FormPart1;
